// src/components/atoms/SearchInput/SearchInput.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

/**
 * SearchInput - Componente atômico para campo de pesquisa
 *
 * CLASSIFICAÇÃO: ÁTOMO
 *
 * Este componente representa um campo de pesquisa básico com ícone.
 * Segue o princípio do Atomic Design como um "átomo", adaptado para MUI.
 *
 * @see https://bradfrost.com/blog/post/atomic-web-design/
 */
const SearchInput = ({
  value,
  onChange,
  placeholder = 'Pesquisar...',
  className = '',
  size = 'small',
  fullWidth = false,
  variant = 'outlined',
  InputProps: inputPropsOverride = {},
  inputProps: htmlInputProps = {},
  sx,
  ...props
}) => {
  const { startAdornment, ...restInputProps } = inputPropsOverride;

  return (
    <TextField
      {...props}
      className={`search-input ${className}`}
      size={size}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      variant={variant}
      InputProps={{
        ...restInputProps,
        startAdornment: startAdornment || (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        )
      }}
      inputProps={{
        ...htmlInputProps,
        style: {
          minWidth: 0,
          ...(htmlInputProps.style || {})
        }
      }}
      sx={{
        minWidth: 0,
        '& .MuiInputBase-root': {
          borderRadius: '8px',
          minWidth: 0,
          overflow: 'hidden'
        },
        '& .MuiInputBase-input': {
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#fff'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#fff'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#ff6600',
          boxShadow: '0 0 0 1.5px #ff6600'
        },
        ...sx
      }}
    />
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  InputProps: PropTypes.object,
  inputProps: PropTypes.object,
  sx: PropTypes.object
};

export default SearchInput;
